module.exports = "https://static.wagwalking.com/_next/static/images/vet-placeholder-8b703f688e3f731f46cb9880399a241a.png";